export type TTermsSection = {
  key: string;
  paragraphs?: readonly string[];
  bullets?: readonly string[];
};

export const TERMS_SECTIONS: readonly TTermsSection[] = [
  {
    key: 'general.information',
    paragraphs: ['line1', 'line2', 'line3', 'line4'],
  },
  {
    key: 'orders',
    paragraphs: ['line1', 'line2', 'line3'],
  },
  {
    key: 'products',
    paragraphs: ['line1', 'line2'],
    bullets: ['item1', 'item2'],
  },
  {
    key: 'payment.methods',
    bullets: ['item1', 'item2', 'item3'],
  },
  {
    key: 'delivery',
    paragraphs: ['line1', 'line2'],
    bullets: ['item1', 'item2'],
  },
  {
    key: 'right.of.withdrawal',
    paragraphs: ['line1', 'line2', 'line3', 'line4'],
    bullets: ['item1', 'item2'],
  },
  {
    key: 'complaints.warranty',
    paragraphs: ['line1', 'line2', 'line3'],
  },
  {
    key: 'personal.data',
    paragraphs: ['line1', 'line2'],
  },
  {
    key: 'final.provisions',
    paragraphs: ['line1', 'line2', 'line3'],
  },
] as const;
